

// Imports ---------------------------------------------------------------------

// Nuxt / Vendor
import Vue from "vue";

// Project
import ContentGateway from "~/libs/ContentGateway";
import { TestimonialContentNode } from "~/libs/Types";
import TestimonialItem from "~/components/Testimonials/Item.vue";

// Export ----------------------------------------------------------------------

export default Vue.extend({

    // Component imports -------------------------------------------------------

    components: {
        TestimonialItem
    },

    // Component Internal Data State -------------------------------------------

    data: () => ({
        testimonials: [] as Array<TestimonialContentNode>,
        active: ""
    }),

    // Nuxt/Vue Hooks ----------------------------------------------------------

    async fetch () {
        this.testimonials = await ContentGateway.make(this.$nuxt.context).homeTestimonials();
    },

    // Component Computed Properties -------------------------------------------

    computed: {
        keyPressMap (): object {
            return {
                esc: this.closeModal
            };
        },

        hasItems (): boolean {
            return this.testimonials.length > 0;
        }
    },

    // Methods / Functions  ----------------------------------------------------

    methods: {
        openModal (item: TestimonialContentNode): void {
            this.active = item.name;
        },

        closeModal () {
            this.active = "";
        },

        isActiveModal (item: TestimonialContentNode): boolean {
            return item.name === this.active;
        }

    }

    // -------------------------------------------------------------------------
});

